import React from 'react';
import { Clickable } from '@moda/om';
import WarningIcon from '@moda/icons/warning-16';
import './LineItemSoldOutNote.scss';

interface Props {
  granularity?: 'minimal' | 'full';
  message: string;
  onSaveForLater: () => void;
}

export const LineItemSoldOutNote: React.FC<Props> = ({
  granularity = 'full',
  message,
  onSaveForLater
}) => (
  <>
    <WarningIcon className="LineItemSoldOutNote__warning-icon" />
    <span>
      {message}
      {granularity === 'full' && (
        <>
          {' '}
          <Clickable className="LineItemSoldOutNote__action" onClick={onSaveForLater}>
            Save for later
          </Clickable>{' '}
          to be notified when item is back in stock.
        </>
      )}
    </span>
  </>
);
